import React from 'react'
import { formatCurrency, formatPercentage } from '@utilities/numbers'
import { formatDateNice } from '@utilities/dates'

function LoanInfo(props) {
  const loan = props.loan
  const loanDoc = props.loanDoc
  return (
    <div className="">
      <dl className="DefinitionList -div-50 ">
        <dt> Start Date</dt> <dd> {formatDateNice(loan.start_date)} </dd>
        <dt> End Date</dt> <dd> {formatDateNice(loan.end_date)} </dd>
        <dt> Loan Amount </dt> <dd> {formatCurrency(loan.amount_borrowed)} </dd>
        {loan.security && (
          <>
            <dt>Property Total Cost</dt>
            <dd> {formatCurrency(Number(loan.security.total_cost))} </dd>
          </>
        )}
        <dt> Lender Interest Rate</dt>
        <dd> {formatPercentage(loan.yearly_interest_rate_at_loan_start)} </dd>
        <dt> Platform Fee Rate</dt>
        <dd> {formatPercentage(loan.yearly_platform_rate_at_loan_start)} </dd>
      </dl>
      <p>{props.children}</p>
      {loanDoc && (
        <p>
          <a href={loanDoc?.url} download={loanDoc?.display_name + '.pdf'}>
            <i className="fas fa-file"></i> {loanDoc?.display_name}
          </a>
        </p>
      )}
    </div>
  )
}
export default LoanInfo
